// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Guinea from '../_raw/flag/icon_flag_guinea.png';

export default () => <img src={Guinea} alt="Guinea" />;
